import colors from 'vuetify/es5/util/colors';
import { Theme, VuetifyThemeVariant } from 'vuetify/types/services/theme';

// Any color names added to theme will need to be added to this interface
interface IExtendedTheme extends VuetifyThemeVariant {
    brandGrey: string;
    mainBackground: string;
    headerBackground: string;
}
export default {
    dark: false,
    themes: {
        light: {
            primary: '#4933da',
            secondary: '#d4009f',
            accent: '#96ff73',
            error: '#DB3939',
            warning: colors.amber.lighten2,
            info: colors.lightBlue.lighten2,
            success: colors.green.lighten2,
            brandGrey: '#757575',
            mainBackground: '#fafafa',
            headerBackground: '#fafafa',
            textColor: '#333333',
        } as Partial<IExtendedTheme>,
        dark: {
            primary: '#4933da',
            secondary: '#d4009f',
            accent: '#96ff73',
            error: '#DB3939',
            warning: colors.amber.lighten2,
            info: colors.lightBlue.lighten2,
            success: colors.green.lighten2,
            brandGrey: '#757575',
            mainBackground: '#fafafa',
            headerBackground: '#fafafa',
            textColor: '#333333',
        } as Partial<IExtendedTheme>,
    },
} as Theme;
